import type { RetryOptions } from '../../types';

export type GetNumberOfAttemptsRemainingParams = {
  retryOptions: RetryOptions;
  numberOfFailedAttempts: number;
};

export const getNumberOfAttemptsRemaining = ({
  retryOptions: { maxRetries },
  numberOfFailedAttempts,
}: GetNumberOfAttemptsRemainingParams): number | undefined => {
  if (maxRetries === undefined) {
    return undefined;
  }

  const maxNumberOfAttempts = Math.floor(maxRetries) + 1;

  return Math.max(0, maxNumberOfAttempts - Math.floor(numberOfFailedAttempts));
};
